// import React, { useState } from "react";
// import styles from "../../styles/Template.module.css";
// import { Button } from "../../components/Modal";
// import { FormData } from "../../hooks/rtmTemplate/index.type";

// interface TemplateTableProps {
//   formData: FormData;
//   setFormData: React.Dispatch<React.SetStateAction<FormData>>;
//   handleDeleteQuestion: (key: string) => void;
//   handleEditQuestion: (key: string) => void;
//   onSubmit?: () => void;
//   onCancel: () => void;
//   isEditing?: boolean;
//   handleToggleEditState?: () => void;
// }

// const TemplateTable: React.FC<TemplateTableProps> = ({
//   formData,
//   setFormData,
//   handleDeleteQuestion,
//   handleEditQuestion,
//   onSubmit,
//   onCancel,
//   isEditing = false,
//   handleToggleEditState,
// }) => {
//   const [draggedIndex, setDraggedIndex] = useState<number | null>(null);

//   const getCategoryName = (categoryId: string) => {
//     const category = formData.categories.find((cat) => cat.key === categoryId);
//     return category ? category.name : "N/A";
//   };

//   const formatAnswerType = (type: string) => {
//     const cleaned = type.includes("_") ? type.split("_")[0] : type;
//     return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
//   };

//   const handleDragStart = (index: number) => {
//     setDraggedIndex(index);
//   };

//   const handleDragOver = (
//     event: React.DragEvent<HTMLTableRowElement>,
//     index: number
//   ) => {
//     event.preventDefault();
//   };

//   const handleDrop = (index: number) => {
//     if (draggedIndex === null || draggedIndex === index) return;

//     const newQuestions = [...formData.questions];
//     const draggedItem = newQuestions[draggedIndex];

//     newQuestions.splice(draggedIndex, 1);
//     newQuestions.splice(index, 0, draggedItem);

//     const updatedQuestions = newQuestions.map((question, idx) => ({
//       ...question,
//       sequence: idx + 1,
//     }));

//     setFormData((prev) => ({
//       ...prev,
//       questions: updatedQuestions,
//     }));

//     setDraggedIndex(null);
//   };

//   const sortedQuestions = [...formData.questions].sort(
//     (a, b) => Number(a.sequence) - Number(b.sequence)
//   );

//   return (
//     <div className={styles.tableWrapper}>
//       <table className={styles.table}>
//         <thead>
//           <tr>
//             <th style={{ width: "6rem" }}>Question No.</th>
//             <th style={{ width: "8rem" }}>Category</th>
//             <th style={{ width: "20rem" }}>Question</th>
//             <th>Answers</th>
//             <th style={{ width: "5rem" }}>Answer Type</th>
//             <th style={{ width: "5rem" }}>Is Dependent?</th>
//             <th style={{ width: "5rem" }}>Has Dependents?</th>
//             <th style={{ width: "4rem" }}>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {sortedQuestions.length > 0 ? (
//             sortedQuestions.map((row, index) => (
//               <tr
//                 key={row.questionId}
//                 draggable
//                 onDragStart={(e) => {
//                   const isButton = (e.target as HTMLElement).closest("button");
//                   if (isButton) return;
//                   handleDragStart(index);
//                 }}
//                 onDragOver={(e) => handleDragOver(e, index)}
//                 onDrop={() => handleDrop(index)}
//                 style={{
//                   cursor: "move",
//                   opacity: draggedIndex === index ? 0.5 : 1,
//                 }}
//               >
//                 <td>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "0.5rem",
//                     }}
//                   >
//                     <span>{row.sequence}</span>
//                   </div>
//                 </td>

//                 <td>{getCategoryName(row.categoryId)}</td>
//                 <td>{row.text}</td>
//                 <td>
//                   {row.answerType === "scale" ? (
//                     <>
//                       <div>
//                         {row.scale?.min?.key} - {row.scale?.min?.name}
//                       </div>
//                       <div>
//                         {row.scale?.max?.key} - {row.scale?.max?.name}
//                       </div>
//                     </>
//                   ) : (
//                     row.option
//                       ?.map((opt, i) => `${i + 1}. ${opt.name}`)
//                       .join(", ")
//                   )}
//                 </td>
//                 <td>{formatAnswerType(row.answerType)}</td>
//                 <td>{row.questionDependable === "yes" ? "Yes" : "No"}</td>
//                 <td>{row.hasQuestionDependOnThis === "yes" ? "Yes" : "No"}</td>
//                 <td style={{ paddingLeft: "0.5rem" }}>
//                   <div
//                     style={{
//                       display: "flex",
//                       flexDirection: "row",
//                       alignItems: "center",
//                       gap: "0.75rem",
//                     }}
//                   >
//                     <button
//                       onDragStart={(e) => e.stopPropagation()}
//                       draggable={false}
//                       className={styles.icon_button}
//                       onClick={() => handleEditQuestion(row.questionId)}
//                       type="button"
//                     >
//                       <svg>
//                         <use xlinkHref={`/assets/sprite.svg#icon-edit-new`} />
//                       </svg>
//                     </button>
//                     {!isEditing && (
//                       <button
//                         onDragStart={(e) => e.stopPropagation()}
//                         draggable={false}
//                         className={styles.icon_button}
//                         onClick={() => handleDeleteQuestion(row.questionId)}
//                         type="button"
//                       >
//                         <svg viewBox="0 0 16 12">
//                           <path d="M4.225 0.553125L4 1H1C0.446875 1 0 1.44687 0 2C0 2.55312 0.446875 3 1 3H13C13.5531 3 14 2.55312 14 2C14 1.44687 13.5531 1 13 1H10L9.775 0.553125C9.60625 0.2125 9.25938 0 8.88125 0H5.11875C4.74062 0 4.39375 0.2125 4.225 0.553125ZM13 4H1L1.6625 14.5938C1.7125 15.3844 2.36875 16 3.15937 16H10.8406C11.6312 16 12.2875 15.3844 12.3375 14.5938L13 4Z" />
//                         </svg>
//                       </button>
//                     )}
//                     <button
//                       onDragStart={(e) => e.stopPropagation()}
//                       draggable={false}
//                       className={styles.icon_grab}
//                       type="button"
//                       style={{ cursor: "move" }}
//                     >
//                       <svg width="16" height="18" viewBox="0 0 16 16">
//                         <path
//                           d="M2 8H14M2 4H14M2 12H14"
//                           stroke="#1E1E1E"
//                           strokeWidth="1.6"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>
//                     </button>
//                   </div>
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan={8} className={styles.noData}>
//                 No Question Added Yet
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default TemplateTable;

import React, { useState } from "react";
import styles from "../../styles/Template.module.css";
import { Button } from "../../components/Modal";
import { FormData } from "../../hooks/rtmTemplate/index.type";
import toast from "react-hot-toast";

interface TemplateTableProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  handleDeleteQuestion: (key: string) => void;
  handleEditQuestion: (key: string) => void;
  onSubmit?: () => void;
  onCancel: () => void;
  isEditing?: boolean;
  handleToggleEditState?: () => void;
}

const TemplateTable: React.FC<TemplateTableProps> = ({
  formData,
  setFormData,
  handleDeleteQuestion,
  handleEditQuestion,
  isEditing = false,
}) => {
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);

  const getCategoryName = (categoryId: string) => {
    const category = formData.categories.find((cat) => cat.key === categoryId);
    return category ? category.name : "N/A";
  };

  const formatAnswerType = (type: string) => {
    const cleaned = type.includes("_") ? type.split("_")[0] : type;
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
  };

  const handleDragStart = (index: number) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (
    event: React.DragEvent<HTMLTableRowElement>,
    index: number
  ) => {
    event.preventDefault();
  };

  const handleDrop = (index: number) => {
    if (draggedIndex === null || draggedIndex === index) return;

    const newQuestions = [...formData.questions];
    const draggedItem = newQuestions[draggedIndex];


    if (
      draggedItem.questionDependable === "yes" &&
      draggedItem.dependableQuestionId
    ) {
      const dependentQuestion = formData.questions.find(
        (q) => q.questionId === draggedItem.dependableQuestionId
      );

      const newSequenceIfMoved = index + 1; 

      if (
        dependentQuestion &&
        newSequenceIfMoved < dependentQuestion.sequence
      ) {
        toast.error(
          `Cannot move this question before the one it depends on (Sequence ${dependentQuestion.sequence}).`
        );
        return;
      }
    }

    newQuestions.splice(draggedIndex, 1);
    newQuestions.splice(index, 0, draggedItem);

    const updatedQuestions = newQuestions.map((question, idx) => ({
      ...question,
      sequence: idx + 1,
    }));

    setFormData((prev) => ({
      ...prev,
      questions: updatedQuestions,
    }));

    setDraggedIndex(null);
  };

  const sortedQuestions = [...formData.questions].sort(
    (a, b) => Number(a.sequence) - Number(b.sequence)
  );

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th style={{ width: "6rem" }}>Question No.</th>
            <th style={{ width: "8rem" }}>Category</th>
            <th style={{ width: "20rem" }}>Question</th>
            <th>Answers</th>
            <th style={{ width: "5rem" }}>Answer Type</th>
            <th style={{ width: "5rem" }}>Is Dependent?</th>
            <th style={{ width: "5rem" }}>Has Dependents?</th>
            <th style={{ width: "4rem" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedQuestions.length > 0 ? (
            sortedQuestions.map((row, index) => (
              <tr
                key={row.questionId}
                draggable
                onDragStart={(e) => {
                  const isButton = (e.target as HTMLElement).closest("button");
                  if (isButton) return;
                  handleDragStart(index);
                }}
                onDragOver={(e) => handleDragOver(e, index)}
                onDrop={() => handleDrop(index)}
                style={{
                  cursor: "move",
                  opacity: draggedIndex === index ? 0.5 : 1,
                }}
              >
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <span>{row.sequence}</span>
                  </div>
                </td>

                <td>{getCategoryName(row.categoryId)}</td>
                <td>{row.text}</td>
                <td>
                  {row.answerType === "scale" ? (
                    <>
                      <div>
                        {row.scale?.min?.key} - {row.scale?.min?.name}
                      </div>
                      <div>
                        {row.scale?.max?.key} - {row.scale?.max?.name}
                      </div>
                    </>
                  ) : (
                    row.option
                      ?.map((opt, i) => `${i + 1}. ${opt.name}`)
                      .join(", ")
                  )}
                </td>
                <td>{formatAnswerType(row.answerType)}</td>
                <td>{row.questionDependable === "yes" ? "Yes" : "No"}</td>
                <td>{row.hasQuestionDependOnThis === "yes" ? "Yes" : "No"}</td>
                <td style={{ paddingLeft: "0.5rem" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "0.75rem",
                    }}
                  >
                    <button
                      onDragStart={(e) => e.stopPropagation()}
                      draggable={false}
                      className={styles.icon_button}
                      onClick={() => handleEditQuestion(row.questionId)}
                      type="button"
                    >
                      <svg>
                        <use xlinkHref={`/assets/sprite.svg#icon-edit-new`} />
                      </svg>
                    </button>
                    {!isEditing && (
                      <button
                        onDragStart={(e) => e.stopPropagation()}
                        draggable={false}
                        className={styles.icon_button}
                        onClick={() => handleDeleteQuestion(row.questionId)}
                        type="button"
                      >
                        <svg viewBox="0 0 16 12">
                          <path d="M4.225 0.553125L4 1H1C0.446875 1 0 1.44687 0 2C0 2.55312 0.446875 3 1 3H13C13.5531 3 14 2.55312 14 2C14 1.44687 13.5531 1 13 1H10L9.775 0.553125C9.60625 0.2125 9.25938 0 8.88125 0H5.11875C4.74062 0 4.39375 0.2125 4.225 0.553125ZM13 4H1L1.6625 14.5938C1.7125 15.3844 2.36875 16 3.15937 16H10.8406C11.6312 16 12.2875 15.3844 12.3375 14.5938L13 4Z" />
                        </svg>
                      </button>
                    )}
                    {row.questionDependable !== "yes" && (
                      <button
                        onDragStart={(e) => e.stopPropagation()}
                        draggable={false}
                        className={styles.icon_grab}
                        type="button"
                        style={{ cursor: "move" }}
                      >
                        <svg width="16" height="18" viewBox="0 0 16 16">
                          <path
                            d="M2 8H14M2 4H14M2 12H14"
                            stroke="#1E1E1E"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8} className={styles.noData}>
                No Question Added Yet
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TemplateTable;
